
import React from 'react';

export default function PersonasSection() {
  const personas = [
    {
      icon: 'ri-women-line',
      title: 'Women',
      subtitle: 'Hormonal Health Focus',
      description: 'Specialized tracking for menstrual cycles, pregnancy, menopause, and hormonal changes that affect oxygen levels.',
      stats: '60% of our beta users',
      benefits: ['Hormonal tracking', 'Pregnancy support', 'Menopause guidance', 'Iron deficiency alerts']
    },
    {
      icon: 'ri-run-line',
      title: 'Athletes',
      subtitle: 'Performance Optimization',
      description: 'Advanced metrics for endurance training, altitude preparation, and recovery optimization.',
      stats: 'Used by 200+ athletes',
      benefits: ['Performance tracking', 'Altitude training', 'Recovery metrics', 'Endurance optimization']
    },
    {
      icon: 'ri-heart-line',
      title: 'Elderly',
      subtitle: 'Age-Related Monitoring',
      description: 'Gentle monitoring for age-related oxygen challenges, medication interactions, and health maintenance.',
      stats: '65+ age group focus',
      benefits: ['Medication tracking', 'Fall risk assessment', 'Chronic condition support', 'Family sharing']
    },
    {
      icon: 'ri-building-line',
      title: 'Metro/Altitude Residents',
      subtitle: 'Environmental Adaptation',
      description: 'Specialized guidance for high-altitude living and urban air quality challenges.',
      stats: 'High-altitude communities',
      benefits: ['Altitude acclimatization', 'Air quality alerts', 'Environmental tracking', 'Location-based tips']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            Designed for
            <br />
            <span className="text-[#12B6B6]">Everyone's Unique Needs</span>
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            OxyAI™ adapts to your specific health profile, lifestyle, and environmental factors 
            to provide the most relevant oxygen health insights.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {personas.map((persona, index) => (
            <div key={index} className="bg-[#FAFAFA] rounded-3xl p-8 text-center hover:shadow-lg transition-all duration-300">
              <div className="w-20 h-20 bg-[#12B6B6] rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className={`${persona.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-[#111111] mb-2">{persona.title}</h3>
              <p className="text-sm text-[#12B6B6] font-medium mb-4">{persona.subtitle}</p>
              
              <p className="text-gray-700 text-sm leading-relaxed mb-6">
                {persona.description}
              </p>

              <div className="bg-[#12B6B6]/10 rounded-xl p-3 mb-6">
                <p className="text-xs font-medium text-[#12B6B6]">{persona.stats}</p>
              </div>

              <div className="space-y-2">
                {persona.benefits.map((benefit, benefitIndex) => (
                  <div key={benefitIndex} className="flex items-center justify-center space-x-2">
                    <i className="ri-check-line text-[#12B6B6] text-xs"></i>
                    <span className="text-xs text-gray-600">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="bg-[#12B6B6]/5 rounded-3xl p-12">
            <h3 className="text-2xl font-bold text-[#111111] mb-4">
              Personalized for Your Journey
            </h3>
            <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-8">
              Our AI learns from your unique health profile and continuously adapts 
              recommendations as your oxygen health journey evolves.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#12B6B6] mb-2">50+</div>
                <div className="text-sm text-gray-600">Health Factors Analyzed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#12B6B6] mb-2">24/7</div>
                <div className="text-sm text-gray-600">Continuous Monitoring</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#12B6B6] mb-2">100%</div>
                <div className="text-sm text-gray-600">Personalized Insights</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
